import angular from 'angular';
import constants from 'app/constants';

import {
  reportsDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import validator, { name as validatorName } from './messages/report-package-unique-name.validator.directive';
import reportPackageNameMessagesTpl from './messages/report-package.name.messages.html';
import selectEditTypeDialog from '../dialog.selectEditType';
import controller from './add-report-package-dialog.controller';
import template from './add-report-package-dialog.html';

class dialogService {
  getOptions($event, {
    customerId, reportPackage, refreshReportPackage, usesUpdatedReportPackaging
  }) {
    return {
      controller,
      controllerAs: 'addReportPackageDialogVM',
      locals: {
        customerId, 
        reportPackage,
        refreshReportPackage,
        usesUpdatedReportPackaging
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.reports.addReportPackageDialog', [
  alerts,
  reportsDataService,
  constants,
  loaderService,
  ssDialogService,
  selectEditTypeDialog,
])
  .directive(validatorName, validator)
  .service('addReportPackageDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('report-package.name.messages.html', reportPackageNameMessagesTpl);
  })
  .name;
